<template>
	<el-dropdown v-bind="{...$attrs, type, splitButton}">
		
		<el-button v-if="hideLabel" v-bind="{size:'small', disabled}" style="border:0px">
			{{ labelKey }}
		</el-button>
		<el-button v-else v-bind="{size:'small', disabled}">
			{{ labelKey }}<i class="el-icon-arrow-down el-icon--right" />
		</el-button>
		<slot />
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item v-for="item in items" :disabled="item.disable" :key="item.labelKey" @click.native="item.click">
			<span class="dd-badge" v-if="item.badge">
			  <el-badge :value="item.value">
			 	 {{ buttonName(item) }}
           	  </el-badge>
			</span>
			<span v-else>
				<i v-if="item.icon" :disabled="item.disable" :icon="item.icon" :class="item.icon" />{{ item.labelKey != null || item.text !=null ? buttonName(item) :null}}
			</span>
			</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
</template>

<script>
import { DmsBaseComponent } from '#components/dms/common/base';
import { BUTTON_TYPES } from '#components/@types/button';


export default DmsBaseComponent.extend({
	name: 'DropButtons',
	props: {
		text:  {type: String, default: null},
		splitButton: { type: Boolean, default: true},
		type: {
			type: String,
			in: BUTTON_TYPES,
		},
		items: Array,
		hideLabel:{ type: Boolean, default: false}
	},			
	
	methods: {
		buttonName(item) {
			return item.todo ? (item.text || this.LocalizePopisostatni(item.labelKey)+" "+item.todo):(  item.text || this.LocalizePopisostatni(item.labelKey));
		},
	},
});
</script>

<style lang="scss">
.el-dropdown {
	.el-button:not(.el-dropdown__caret-button) {
		padding-right: 3px;
		height: 33px;
   		margin-top: 1px;
	}
}
.el-dropdown-menu__item i {
    margin-right: 0px;
    font-size: 15px;
}
.dd-badge{
	.el-badge {
		.el-badge__content {
			z-index: 10;
			font-size: 11px;
			padding: 0 6px;
			font-weight: bold;
			background-color:#4E5163;
			height: 20px;

			&.is-fixed {
				    right: 0px;
    				top: 7px;
			}
		}
	}
	.el-badge + .el-badge, .el-badge + .el-button, .el-button + .el-badge {
		margin-left: 10px;
	}
}
</style>
